import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue, useWillPipe } from '@morningtrain/react-helpers'
import { useModel } from '@morningtrain/react-resources'
import { toJS } from 'mobx'

export default function SupplierCategoriesToEnvOnPipe (props) {
  const model = useModel()
  const [envCategories, setEnvCategories] = useEnvValue('globals.inventory.supplier_categories')

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      const categories = model.get('category_ids')

      setEnvCategories(toJS(categories))

      resolve(payload)
    })
  })

  React.useEffect(() => {
    return () => {
      setEnvCategories({})
    }
  }, [])

  return null
}
